<template>
  <form style="padding: 20px" v-if="fields">  
    <v-snackbar
      top right
      v-model="snackbar"
      :timeout="timeout"
    >
      enviado
    </v-snackbar>
    <div v-for="(item) of fields"
      :style="{ 'padding-bottom': item.type === 'info' ? '20px' : null}"
    >
      <span 
        v-if="item.type !== 'checkbox'"
        class="label-form" 
        :style="{ fontSize: item.type === 'info' ? `${FontSizeContent+5}px` : `${FontSizeContent}px`,
                  color: item.type === 'info' ? BGColor : ColorContent,
                  fontFamily: FontContent
                }"
        style="margin-bottom: 10px;line-height:1;"
      >
        {{ getTranslation(item.label, locale).concat(item.required && item.type !== 'info' ? ' *' : '') }}
      </span>
      <v-text-field
        v-if="item.type === 'string'"
        solo
        v-model="item.value"
        :required="item.required"
      />
      <v-select
        v-else-if="['select', 'selectMultiple'].indexOf(item.type) >= 0"
        :items="item.tItems"
        solo
        itemValue="id"
        itemText="name"
        :multiple="item.type === 'selectMultiple'"
        v-model="item.value"
        :required="item.required"
      />
      <form-date
        v-else-if="item.type === 'date'"
        :label="getTranslation(item.label, locale)"
        :value="item.value"
        :onChange="(v) => { item.value = v}"
      />
      <v-checkbox
        v-else-if="item.type === 'checkbox'"
        :label="getTranslation(item.label, locale)"
        v-model="item.value"
        :required="item.required"
        hide-detail
      />
    </div>
    
    <privacy
      v-if="workspaceID"
      :workspaceID="workspaceID"
      :locale="locale"
      :onLoadChangePrivacyPolicy="handleChangePrivacyPolicy"
    />
    <message-confirm
      v-if="messageConfirm"
      :messageConfirm="messageConfirm"
      :showMessageConfirm="showMessageConfirm"
      :locale="locale"
      :onClose="handleClose"
      :color="BGColor"
    />

    <v-alert
      v-if="error"
      color="red"
      dense
      text
      icon="mdi-information"
      border="left"
    >
      {{ $t('common.required', locale) }}
    </v-alert>
    <v-progress-linear
      v-if="loading"
      indeterminate
      :color="BGColorSecundary"
    />
    <v-btn 
      :color="BGColorSecundary" 
      :style="{ 'color': ColorSecundary}" 
      dark 
      block 
      style="margin-top:20px;height:50px;" 
      :disabled="loading"
      @click="handleSubmit"
      >
        {{ text ? text : $t('common.send', locale) }}
    </v-btn>    
  </form>
</template>

<script>
  import { mapState } from 'vuex'
  import { validationMixin } from 'vuelidate'
  import { required, maxLength, email, sameAs } from 'vuelidate/lib/validators'
  import constants from '@/constants'
  import axios from 'axios'
  import api from '@/services/api'
  import utils from '@/services/utils'
  import privacy from '@/components/privacy'
  import FormDate from './FormDate'
  import MessageConfirm from './MessageConfirm'
  import info from './info'

  export default {
    mixins: [validationMixin],
    components: {
      FormDate,
      privacy,
      MessageConfirm,
    },
    props: {
      data: {
        type: Object,
        required: true,
        default: null
      },
      onSend: {
        type: Function,
        default: null,
      },
    },
    data: () => ({
      fields: null,
      snackbar: false,
      timeout: 2000,
      loading: false,
      error: false,
      privacyPolicyRequired: false,
      privacyPolicyAgree: false,
      workspaceID: null,
      messageConfirm: null,
      showMessageConfirm: false,
    }),
    computed: {
      ...mapState('app',['webappWorkspaceID', 'locale', 'FontContent', 'FontSizeContent', 'ColorContent', 'BGColor', 'BGColorSecundary', 'ColorSecundary']),
      text () {
        return this.data.FormTextBtn ? utils.getTranslation (this.data.FormTextBtn, this.locale) : null
      },
      btnTextColor () {
        return this.$store.state.app.btnTextColor && this.$store.state.app.btnTextColor !== '' ? this.$store.state.app.btnTextColor : 'white'
      },
      btnBackgroundColor () {        
        return this.$store.state.app.btnBackgroundColor && this.$store.state.app.btnBackgroundColor !== '' ? this.$store.state.app.btnBackgroundColor : this.BGColor
      },
      isSimulation () {
        return constants.simulationsRutes.indexOf(this.$route.path.split('/')[1]) >= 0
      },
      isDesktop () {
        return !utils.isMobile()
      },
      enterpriseID () {
        return this.$store.state.app.enterpriseID
      },
      nameErrors () {
        const errors = []
        if (!this.$v.name.$dirty) return errors
        !this.$v.name.maxLength && errors.push(this.$t('enterprises.messages.nameMostCharacters'))
        !this.$v.name.required && errors.push(this.$t('enterprises.messages.nameRequired'))
        return errors
      },
    },
    watch: {
      'data.FormCioFieldsConfig' () {
        this.prepareData()
      },
      validations () { 
        return {
          name: { required, maxLength: maxLength(150) },
        }
      },
      locale () {
        this.prepareTranslate()
      },
      webappWorkspaceID () {
        this.workspaceID = this.webappWorkspaceID
      },
    },
    mounted () {
      this.workspaceID = this.webappWorkspaceID
      this.prepareData()
    },
    methods: {
      handleChangePrivacyPolicy (required, agree) {
        this.privacyPolicyRequired = required
        this.privacyPolicyAgree = agree
      },
      prepareData () {
        api.getAll(`form-cio`, false, 1, 10000, '', `${this.data.FormCioFieldsConfig || this.data.SiteForm}/fields`).then(response => {
          let aux = response.shift()
          this.messageConfirm = aux && aux.MessageConfirm ? JSON.parse(aux.MessageConfirm) : null
          aux = JSON.parse(aux.Config)
          this.fields = aux.map(item => {
            if (['select', 'selectMultiple'].indexOf(item.type) >= 0) item.tItems = this.translateArray(item.items)
            return item
          })
        })
      },
      translateArray (v) {
        return JSON.parse(JSON.stringify(v)).map(item => {
          item.name = utils.getTranslation(item.name, this.locale)
          return item
        })
      },
      prepareTranslate () {
        if (!this.fields) return
        this.fields = this.fields.map(item => {
          if (item.type === 'select') item.tItems = this.translateArray(item.items)
          return item
        })
      },
      getTranslation (v, locale) {
        return utils.getTranslation(v, locale)
      },
      handleSubmit () {
        if (!this.fields) return 


        if (this.fields.filter(x => x.required && (!x.value || x.value.length === 0)).length > 0) {
          alert (` (*) ${this.$t('common.required', this.locale)}`)
          this.error = true
          return
        }

        if (this.privacyPolicyRequired && !this.privacyPolicyAgree) {
          alert (` (*) ${this.$t('common.required', this.locale)}`)
          this.error = true
          return
        }

        this.error = false
        const body = {
          result: this.fields,
          agreePrivacyPolicy: this.privacyPolicyRequired ? this.privacyPolicyAgree : null
        }
        /*
        if (!this.name || this.name.length === 0
        || !this.ni || this.ni.length === 0
        || !this.phone || this.phone.length === 0) { 
          this.error = true
          return
        }*/
        
        const that = this
        this.loading = true
        api.addPublicItem(`form-cio/${this.data.FormCioFieldsConfig || this.data.SiteForm}/result`, body)
          .then(response => {
            if (this.messageConfirm)
              this.showMessageConfirm = true
            else this.handleClose()
          })
      },
      handleClose () {
        this.showMessageConfirm = false
        this.snackbar = true
        this.loading = false
        this.onSend()
      },
    }
  }
</script>
<style scoped>
  .label-form {
    margin-bottom: 10px;
  }
</style>
